import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-input-checkbox',
  templateUrl: './input-checkbox.component.html',
  styleUrls: ['./input-checkbox.component.scss']
})
export class InputCheckboxComponent {

  @Input() id: string;
  @Input() title: string;
  @Input() name: string;
  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() readonly: boolean;

  constructor() { }

  get formControl(): AbstractControl {

    return this.formGroup.controls[this.controlName];
  }

}
